import toast from "react-hot-toast";
import { postAnswer } from "@/api/quiz";
import axios from "axios";
import { PostAnswerParams } from "@/types";

export type ErrorResponse = {
  status?: number;
  responseMessage?: any;
};

export const submitQuizAnswer = async (
  answerData: PostAnswerParams,
  questionOrder?: number
) => {
  try {
    await postAnswer(answerData, questionOrder);
  } catch (error) {
    let errorMessage = "An error occurred";
    if (axios.isAxiosError(error)) {
      return {
        status: error?.response?.status,
        responseMessage: error?.response?.data,
      } satisfies ErrorResponse;
    } else if (error instanceof Error) {
      errorMessage = error.message;
    }

    toast.error(errorMessage);
  }
};
